<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:body>
            <b-overlay :show="unitLoad" rounded="sm">
                <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                    <b-form @submit.prevent="handleSubmit(storeData)" @reset.prevent="reset">
                        <b-row>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Applicant Mobile" vid="applicant_mobile" rules="required|numeric">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="applicant_mobile"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('admission_management.applicant_mobile')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            :disabled="id ? true : false"
                                            v-model="admission.student_mobile"
                                            id="applicant_mobile"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        </b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col v-if="!id" lg="6" sm="6">
                                <b-spinner v-if="loadingData" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                <ValidationProvider name="Applicant name" vid="applicant_name" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="applicant_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('admission_management.applicant_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        @change="getApplicantInfo(admission.admission_id)"
                                        v-model="admission.admission_id"
                                        :options="tmpApplicantList"
                                        id="applicant_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col v-else lg="6" sm="12" class="applicant-div">
                                <b-spinner v-if="loadingData" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                <ValidationProvider name="Applicant name" vid="applicant_name" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="applicant_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('admission_management.applicant_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                        readonly
                                        v-model="admission.applicant_name"
                                        id="applicant_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-input :value="0">{{$t('globalTrans.select')}}</b-form-input>
                                    </template>
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" sm="6">
                                <b-spinner v-if="loadingData" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                <ValidationProvider name="Year" vid="fiscal_year_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="fiscal_year_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.year')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        disabled
                                        v-model="admission.year"
                                        :options="yearList"
                                        id="fiscal_year_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="6">
                                <b-spinner v-if="loadingData" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="org_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        disabled
                                        v-model="admission.org_id"
                                        :options="orgList"
                                        id="org_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="6">
                                <b-spinner v-if="loadingData" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="institute_type"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('ds_institute_management.institute_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        disabled
                                        v-model="admission.office_type_id"
                                        :options="officeTypeList"
                                        id="office_type_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="6">
                                <b-spinner v-if="loadingData" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                <ValidationProvider name="Institute" vid="office_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="institute_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('ds_institute_management.institute_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        disabled
                                        v-model="admission.office_id"
                                        :options="officeList"
                                        id="office_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" sm="6">
                                <ValidationProvider name="Class" vid="class_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="class_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('online_admission.class')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="admission.class_id"
                                        :options="classList"
                                        id="class_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <ValidationProvider name="Admission Fee Type" vid="fee_type" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="2"
                                        label-for="fee_type"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <b-form-radio-group
                                            v-model="admission.fee_type"
                                            :options="getFeeTypeList"
                                            value-field="value"
                                            text-field="name"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-radio-group>
                                        <div class="invalid-feedback d-block">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col v-if="admission.fee_type === 2" lg="6" sm="12">
                                <ValidationProvider name="Admission fee" vid="admission_fee" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="admission_fee"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('admission_management.admission_fee')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            type="number"
                                            v-model="admission.admission_fee"
                                            id="admission_fee"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        </b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col v-if="admission.fee_type === 2" lg="6" sm="12">
                                <ValidationProvider name="Monthly fee" vid="monthly_fee" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="monthly_fee"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{ $t('admission_management.monthly_fee') }} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            type="number"
                                            v-model="admission.monthly_fee"
                                            id="monthly_fee"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        </b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="6">
                                <ValidationProvider name="Remarks" vid='remarks_en' rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="remarks_en"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{ $t('globalTrans.remarks')}}
                                        </template>
                                        <b-form-input
                                            id="remarks_en"
                                            v-model="admission.remarks"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <div class="row">
                            <div class="col text-right">
                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                &nbsp;
                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                            </div>
                        </div>
                    </b-form>
                </ValidationObserver>
            </b-overlay>
        </template>
    </iq-card>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { admissionFeeStoreApi, admissionFeeUpdateApi, getApplicantByMobileApi } from '../../api/routes'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            unitLoad: false,
            loadingData: false,
            officeTypeList: [],
            officeList: [],
            admission: {
                year: 0,
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                admission_id: 0,
                applicant_name: '',
                student_mobile: '',
                class_id: 0,
                fee_type: 0,
                admission_fee: '',
                monthly_fee: '',
                remarks: ''
            },
            tmpApplicantList: [],
            feeTypeList: [
                { value: 1, text_en: 'Full Scholarship', text_bn: 'সম্পূর্ণ বৃত্তিপ্রাপ্ত' },
                { value: 2, text_en: 'Self Fund', text_bn: 'স্ব-তহবিল' }
            ]
        }
    },
    created () {
         this.admission.org_id = this.$store.state.dataFilters.orgId
         this.admission.office_type_id = this.$store.state.dataFilters.officeTypeId
         this.admission.office_id = this.$store.state.dataFilters.officeId
        if (this.id) {
            const tmp = this.getFeeData()
            // this.admission = tmp
            this.admission.admission_id = tmp.admission_id
            this.admission.applicant_name = this.$i18n.local === 'bn' ? tmp.admission.name_bn : tmp.admission.name_en
            this.admission.student_mobile = tmp.admission.mobile_no
            this.admission.class_id = tmp.admission.class_id
            this.admission.student_id = tmp.admission.student_id
            this.admission.org_id = tmp.org_id
            this.admission.office_type_id = tmp.office_type_id
            this.admission.office_id = tmp.office_id
            this.admission.fee_type = tmp.fee_type
            this.admission.admission_fee = tmp.admission_fee
            this.admission.monthly_fee = tmp.monthly_fee
            this.admission.remarks = tmp.remarks
            this.admission.year = tmp.year
            this.admission.admission_id = tmp.admission_id
        }
    },
    mounted () {
        core.index()
    },
    computed: {
        getFeeTypeList: function () {
            return this.feeTypeList.map(item => {
                return Object.assign({}, item, { value: item.value, name: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
            })
        },
        yearList: function () {
            return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item, text: this.$n(item, { useGrouping: false }) }
                } else {
                    return item
                }
            })
        },
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        classList: function () {
            return this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
        }
    },
    watch: {
        'admission.org_id': function () {
            this.officeTypeList = this.getOfficeTypeList()
        },
        'admission.office_type_id': function () {
            this.officeList = this.getOfficeList()
        },
        'admission.student_mobile': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                if (!this.id) {
                    if (newVal.length === 11) {
                        this.getApplicantName(newVal)
                    }
                }
            }
        }
    },
    methods: {
        getApplicantInfo (Id) {
            if (this.tmpApplicantList.length > 0 && Id) {
                const Obj = this.tmpApplicantList.find(el => el.value === parseInt(Id))
                this.admission.year = Obj.year_id
                this.admission.org_id = Obj.org_name_id
                this.admission.office_type_id = Obj.inst_type_id
                this.admission.office_id = Obj.inst_name_id
            } else {
                this.admission.year = 0
                this.admission.org_id = 0
                this.admission.office_type_id = 0
                this.admission.office_id = 0
            }
        },
        getFeeData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getApplicantName (mobile) {
            this.loadingData = true
            RestApi.getData(disabilitySchoolServiceBaseUrl, getApplicantByMobileApi, { student_mobile: mobile, app_status: 1 }).then(response => {
                if (response.success) {
                    this.tmpApplicantList = response.data.map(el => {
                        return Object.assign({}, el, { value: el.id, text: this.$i18n.local === 'bn' ? el.name_bn : el.name_en })
                    })
                    this.loadingData = false
                } else {
                    this.loadingData = false
                }
            })
        },
        getOfficeTypeList () {
            return this.$store.state.commonObj.officeTypeList.filter(officeType => officeType.org_id === this.admission.org_id)
        },
        getOfficeList () {
            return this.$store.state.commonObj.officeList.filter(office => office.office_type_id === this.admission.office_type_id)
        },
        async storeData () {
            this.unitLoad = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }

            if (this.id) {
                result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${admissionFeeUpdateApi}/${this.id}`, this.admission)
            } else {
                result = await RestApi.postData(disabilitySchoolServiceBaseUrl, admissionFeeStoreApi, this.admission)
            }

            this.$store.dispatch('mutateCommonProperties', loadinState)

            if (result.success) {
                this.$store.dispatch('DisabilitySchoolService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.unitLoad = false
                this.$bvModal.hide('modal-4')
            } else {
                this.unitLoad = false
                if (!this.id) {
                    this.$toast.error({
                        message: result.message,
                        color: '#D6E09B'
                    })
                }
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}
</script>
<style scoped>
    .overlay {
        position: absolute;
        left: 60%;
        z-index: 9999;
        top: 10px;
    }
    .applicant-div {
        position: relative;
    }
</style>
